import { dispatchAndUnwrap } from 'helpers/api';
import { masterDataApi } from 'services/masterDataApi';
import { setCompanyName } from 'store/appSlice';
import { setSiteId, setWFHNavigation } from 'store/navigationSlice';

export async function setCompanyInformation(dispatch, masterData, user) {
  const companyResult = await dispatchAndUnwrap(
    dispatch,
    masterDataApi.endpoints.getMasterDataCompany,
    {
      siteId: user?.site,
    }
  );

  dispatch(setCompanyName({ companyName: companyResult?.companyName }));
  dispatch(setWFHNavigation(masterData));
  dispatch(setSiteId({ siteId: user?.site }));
}
